import { PriceScopeType } from '../constants/price-scope-type.js';
// WHY: never returns MARKET -- the new UI never writes one (a state-scoped, customer/product-less
// rule is indistinguishable from CATEGORY_DEFAULT at the resolver, since brand_market_config caps
// a brand to one active market per state; see revision doc §6, "Why MARKET is not a separate
// audience") -- existing MARKET rows are untouched and keep resolving as before.
export function derivePriceScopeType(customerId, productId) {
    if (customerId && productId)
        return PriceScopeType.ACCOUNT_PRODUCT;
    if (productId)
        return PriceScopeType.PRODUCT;
    if (customerId)
        return PriceScopeType.ACCOUNT;
    return PriceScopeType.CATEGORY_DEFAULT;
}
//# sourceMappingURL=derive-price-scope-type.js.map